import { render, staticRenderFns } from "./orderNum.vue?vue&type=template&id=056155ae&scoped=true&"
import script from "./orderNum.vue?vue&type=script&lang=js&"
export * from "./orderNum.vue?vue&type=script&lang=js&"
import style0 from "./orderNum.vue?vue&type=style&index=0&id=056155ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056155ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056155ae')) {
      api.createRecord('056155ae', component.options)
    } else {
      api.reload('056155ae', component.options)
    }
    module.hot.accept("./orderNum.vue?vue&type=template&id=056155ae&scoped=true&", function () {
      api.rerender('056155ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/components/orderNum.vue"
export default component.exports